import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import modules from '#/redux/modules';

const withConfig = Component => {
  const mapStateToProps = state => {
    const data = modules.config.selectors.getRootSelector()(state);

    if (data && data.__isError) {
      return {
        failedToLoad: data.content
      };
    }

    if (!data || !data.content || data.__isFetching) {
      return {
        loaded: false,
        isLoading: data ? data.__isFetching : false
      };
    }

    return {
      config: data.content,
      loaded: true
    };
  };

  class ConfigLoader extends React.Component {
    static loadData({ dispatch, isLoading }) {
      if (isLoading) {
        return;
      }

      dispatch(modules.config.actions.getData());
    }

    componentDidMount() {
      ConfigLoader.loadData(this.props);
    }

    componentDidUpdate() {
      ConfigLoader.loadData(this.props);
    }

    retryLoad() {
      this.props.dispatch(modules.config.actions.retry());
    }

    render() {
      return <Component onRetry={this.retryLoad.bind(this)} {...this.props} />;
    }
  }

  ConfigLoader.propTypes = {
    dispatch: PropTypes.func
  };

  return connect(mapStateToProps)(ConfigLoader);
};

export default withConfig;
